import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Profile, Password, Addbalance } from './model/model.class';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AppService } from '../shared/service/AppService.class';

declare let paypal: any;

@Injectable()
export class ProfileService extends AppService<Profile>{
  iduser: string;
  usersid: number;
  addScript: boolean = false;
  paypalLoad: boolean = true;

  finalAmount: number = 1;
  constructor(protected http: HttpClient) {
    super(http);
    this.iduser = sessionStorage.getItem('iduser');
    this.appmod = "profile";
  }

  public savethresholdBalance(data: any): Observable<any> {
    this.appmod = "thresholdbalance";
    let result = super.updateService(data, 0);
    this.appmod = "profile";
    return result;
  }
  public supplier(data: any): Observable<any> {
    console.log("data of supplier",data);
    
    this.appmod = "addsupplier";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }
  public getsSupplier():Observable<any>{
    this.appmod = "getSsupplier";
    let result = super.getService();
    this.appmod = "profile";
    return result;
  }

  public updateProfile(data: any): Observable<any> {
    this.appmod = "profileupdate";
    let result = super.updateService(data, 0);
    this.appmod = "profile";
    return result;
  }
  public AgentChannelNo(data:any): Observable<any> {
    let tmp: string = this.appmod
    this.appmod = "AgentChannelNo"
    let result = super.saveService(data)
    this.appmod = tmp
    return result
  }

  public BalanceAndLicenseCount(): Observable<any> {
    let tmp: string = this.appmod
    this.appmod = "get_balance_license_count"
    let result = super.getService(this.appmod)
    this.appmod = tmp
    return result
  }
  public getPackageList(): Observable<any>{
    this.appmod = "packageList";
    let result = super.getService();
    this.appmod = "profile";
    return result;
  }
  public Add_cards(data:any): Observable<any>{
    this.appmod = "custom/Add_card_Details";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }

  public makeDefault(data:any): Observable<any>{
    this.appmod = "custom/makeDefault";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }

  public deletecard(data: any): Observable<any> {
    let temp = this.appmod
    this.appmod = "custom/deletcard";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  public setAmount(data:any): Observable<any>{
    this.appmod = "custom/setAmount";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }

  public getcardToken(data:any):Observable<any>{
    this.appmod = "custom/generateToken";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }
  public addamount(data:any):Observable<any>{
    this.appmod = "custom/AddAmount";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }
  public usercredit(data:any):Observable<any>{
    this.appmod = "custom/creditamount";
    let result = super.saveService(data);
    this.appmod = "profile";
    return result;
  }

  public getpayment(): Observable<any>{
    this.appmod = "custom/getpayment";
    let result = super.getService();
    this.appmod = "profile";
    return result;
  }
}

@Injectable()
export class PasswordService extends AppService<Password>{
  iduser: string;
  constructor(protected http: HttpClient) {
    super(http);
    this.iduser = sessionStorage.getItem('iduser');
    this.appmod = "profile";
  }

}